export default __webpack_public_path__ + "static/media/ico_feature_3.afee27cd.svg";